<template>
  <div :class="flowEdit ? 'modal-container-edit' : ''">
    <base-info :flowEdit="flowEdit" :isSubmit="isSubmit" :isSave="isSave" :isCancel="isCancel" :detailData="detailData"
               v-bind="$attrs"
               v-on="$listeners" :contractListType="contractListType" @setBusType="getBusType"></base-info>
    <buyer :shipperType="shipperType" :isSave="isSave" :isSubmit="isSubmit" :isCancel="isCancel" v-bind="$attrs"
           v-on="$listeners" :detailData="detailData" @setPalletType="getPalletType"></buyer>
    <seller :palletType="palletType" :isSave="isSave" :isSubmit="isSubmit" :isCancel="isCancel" :detailData="detailData"
            v-bind="$attrs" v-on="$listeners" @setShipperType="getShipperType"></seller>
    <goods :busType="busType" :isSubmit="isSubmit" :isSave="isSave" :isCancel="isCancel" :detailData="detailData"
           v-bind="$attrs" v-on="$listeners" :goodsTypeOptions="goodsTypeOptions"></goods>
    <logistics :busType="busType" :cityData="cityData" :isSubmit="isSubmit" :isCancel="isCancel" :isSave="isSave"
               v-bind="$attrs" v-on="$listeners" :detailData="detailData" @setShipInfo="setShipInfo"></logistics>
    <ship v-if="busType === 1 || busType === 3" :isSubmit="isSubmit" :isSave="isSave" :isCancel="isCancel" ref="ship"
          v-bind="$attrs" v-on="$listeners" :detailData="detailData"></ship>
    <ele-contract v-if="busType === 1 || busType === 3" :isSubmit="isSubmit" :isCancel="isCancel" :isSave="isSave"
                  v-bind="$attrs" v-on="$listeners" :detailData="detailData"></ele-contract>
    <sup-agree v-if="busType === 1 || busType === 3" :isSubmit="isSubmit" :isCancel="isCancel" :isSave="isSave"
               v-bind="$attrs" v-on="$listeners" :detailData="detailData"></sup-agree>
    <special-agree :isSubmit="isSubmit" :isCancel="isCancel" :isSave="isSave" :busType="busType" v-bind="$attrs"
                   v-on="$listeners" :detailData="detailData" ref="specialAgree"></special-agree>
    <div class="footer add-btn-box" v-if="flowEdit">
      <Button @click="cancel" style="width: 100px;border-radius: 4px;">取 消</Button>
      <Button type="primary" @click="commit" style="border-radius: 4px;">确 定</Button>
    </div>
  </div>
</template>

<script>
  import BaseInfo from "@/components/contract/Base";
  import Buyer from "@/components/contract/Buyer";
  import Seller from "@/components/contract/Seller";
  import Goods from "@/components/contract/Goods";
  import Logistics from "@/components/contract/Logistics";
  import Ship from "@/components/contract/Ship";
  import EleContract from "@/components/contract/EleContract";
  import SupAgree from "@/components/contract/SupAgree";
  import SpecialAgree from "@/components/contract/SpecialAgree";
  import $api from "@/apiProvider";
  import {hideLoading, showLoading} from "@/utils/util";

  var appData = require("@/assets/json/zz.json");

  export default {
    props: {
      isSubmit: {
        type: Boolean,
        default: false
      },
      isCancel: {
        type: Boolean,
        default: false
      },
      isSave: {
        type: Boolean,
        default: false
      },
      flowEdit: {
        type: Boolean,
        default: false
      },
    },
    components: {BaseInfo, Buyer, Seller, Goods, Logistics, Ship, EleContract, SupAgree, SpecialAgree},
    data() {
      return {
        busType: null,
        palletType: null,
        shipperType: null,
        isLoaded: false,
        detailData: {},
        contractListType: [],
        goodsTypeOptions: [],
        cityData: [],
        special: [],
      }
    },
    mounted() {

    },
    methods: {
      setShipInfo(row) {
        if (this.busType === 1 || this.busType === 3) {
          this.$refs.ship.setShipInfo(row);
        }
      },
      init() {
        this.getDicData();
        this.getCityData();
      },
      commit() {
        this.$emit('update');
      },
      cancel() {
        this.$emit('close');
      },
      async initBySave(id) {
        this.isInitBySave = true;
        this.initBySaveId = id;
        $api.flowInstance.queryDraftFlowDetail
          .GET({
            params: {
              id
            }
          })
          .then(res => {
            if (res.status === 1) {
              this.proData = Object.assign({}, res.data);
              this.isLoaded = true;
              this.getContractPalletDetail(id);
            } else {
              this.$XModal.alert({
                message: res.message ? res.message : "接口异常",
                status: "error"
              });
            }
          });
      },
      async getContractPalletDetail(id,type) {
        this.getDicData();
        this.getCityData();
        let res = await $api.eleContract.request("getContractPalletDetail", {
          flowId: id
        });
        if (res.status === 1) {
          this.busType = res.data.contractType;
          if (res.data.palletName === res.data.firstPartyName) {
            this.palletType = 1;
            res.data.palletType = 1;
          } else {
            this.palletType = res.data.secondPartyType;
            res.data.palletType = res.data.secondPartyType;
            res.data.palletPhone = res.data.secondPartyPhone;
          }
          if (res.data.shipperName === res.data.firstPartyName) {
            this.shipperType = 1;
            res.data.shipperType = 1;
          } else {
            this.shipperType = res.data.secondPartyType;
            res.data.shipperType = res.data.secondPartyType;
            res.data.shipperPhone = res.data.secondPartyPhone;
          }
          if (type) {
            res.data.contractNum = null;
          }
          this.$nextTick(() => {
            this.detailData = res.data;
          })
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      getBusType(val) {
        this.busType = val;
        this.$refs.specialAgree.changeBsType(val);
      },
      getPalletType(val) {
        this.palletType = val;
      },
      getShipperType(val) {
        this.shipperType = val;
      },
      getFlowData() {
        let obj = {flowTempletId: 12};
        $api.flowInstance.createFlowModel
          .GET({
            params: obj
          })
          .then(res => {
            if (res.status === 1) {
              this.$set(this, 'proData', res.data)
              this.isLoaded = true;
            } else {
              this.$XModal.confirm(res.message).then(() => {
                this.close();
              });
            }
          });
      },
      getCityData() {
        appData.forEach(item => {
          let obj = {
            value: item.label,
            label: item.label
            // children: [],
            // loading: false
          };
          this.cityData.push(obj);
        });
      },
      getDicData() {
        this.contractListType = [];
        this.goodsTypeOptions = [];
        this.unitTypeOptions = [];
        $api.other.getContractType
          .GET({
            params: {
              page: 1,
              rows: 100
            }
          })
          .then(res => {
            res.data.forEach(item => {
              let obj = {
                label: item.dictText,
                value: parseInt(item.encoded)
              };
              this.contractListType.push(obj);
            });
          });
        $api.other.getGoodsTypeModel
          .GET({
            params: {
              page: 1,
              rows: 100
            }
          })
          .then(res => {
            res.data.forEach(item => {
              let obj = {
                label: item.dictText,
                value: item.dictText
              };
              this.goodsTypeOptions.push(obj);
            });
          });
        $api.other.getUnitTypeModel
          .GET({
            params: {
              page: 1,
              rows: 100
            }
          })
          .then(res => {
            res.data.forEach(item => {
              let obj = {
                label: item.dictText,
                value: item.dictText
              };
              this.unitTypeOptions.push(obj);
            });
          });
      },
    }
  }
</script>

<style>
  .modal-container-edit {
    box-sizing: border-box;
    padding: 20px 60px;
    background: #F5F7F9;
  }

  .blockC {
    background: #FFFFFF;
    box-shadow: 0px 0px 6px 0px rgba(211, 211, 211, 0.75);
    padding: 10px;
  }

  .blockC-detail {
    display: flex;
    align-items: center;
    box-sizing: border-box;
  }

  .blockC-tip {
    width: 4px;
    height: 16px;
    background: #539fff;
  }

  .blockC-title {
    font-size: 14px;
    font-family: Microsoft YaHei, sans-serif;
    font-weight: 400;
    color: #19233E;
    line-height: 16px;
    margin-left: 6px;
  }

  .radioGroup {
    display: flex;
    align-items: center;
  }

  .footer {
    box-sizing: border-box;
    padding: 20px 0;
    display: flex;
    justify-content: flex-end;
  }
</style>